export const hero = {
  "title": "Ανταλλάξτε μεταξύ οικοδεσποτών,",
  "titleHighlight": "σε όλη την Ευρώπη",
  "subtitle": "Ευρωπαϊκό κλαμπ ανταλλαγής για οικοδεσπότες Airbnb με βαθμολογία 4,5+ και ενιαία ευρωπαϊκή συνδρομή.",
  "cta": "Ξεκινήστε την ανταλλαγή",
  "learnMore": "Μάθετε περισσότερα",
  "stats": {
    "owners": "Ενεργοί ιδιοκτήτες",
    "countries": "Διαθέσιμες χώρες",
    "exchanges": "Ολοκληρωμένες ανταλλαγές"
  },
  "slogans": {
    "slogan1": {
      "title": "Ιδιωτικό κλαμπ",
      "highlight": "οικοδεσπότες Airbnb 4.5+",
      "subtitle": "Πρόσβαση αποκλειστικά για οικοδεσπότες με υψηλή βαθμολογία για ανταλλαγές σε πλαίσιο εμπιστοσύνης."
    },
    "slogan2": {
      "title": "Προσφορά γνωριμίας 2026",
      "highlight": "-50% για τους πρώτους 1000",
      "subtitle": "25EUR/έτος αντί για 50EUR/έτος, με εγγυημένη τιμή εφ' όρου ζωής."
    },
    "slogan3": {
      "title": "Εγγυημένη τιμή εφ' όρου ζωής",
      "highlight": "1000 πρώτα μέλη",
      "subtitle": "Οι πρώτοι 1000 εγγεγραμμένοι διατηρούν την τιμή τους για πάντα."
    },
    "slogan4": {
      "title": "Χωρίς μεσάζοντες,",
      "highlight": "μόνο σύνδεση",
      "subtitle": "Μια κοινότητα εμπιστοσύνης όπου ανταλλάσσουμε διαμονές, δεν πουλάμε διανυκτερεύσεις."
    },
    "slogan5": {
      "title": "Γίνετε μέλος του κλαμπ",
      "highlight": "DONKEY TRAVEL",
      "subtitle": "Το κλαμπ ανταλλαγής σχεδιασμένο για ενεργούς οικοδεσπότες Airbnb στην Ευρώπη."
    },
    "slogan6": {
      "title": "Χαμηλή περίοδος",
      "highlight": "βελτιστοποιημένη",
      "subtitle": "Μετατρέψτε τις νεκρές περιόδους σας σε ταξιδιωτικές ευκαιρίες."
    },
    "slogan7": {
      "title": "Κάντε ένα διάλειμμα,",
      "highlight": "αποφύγετε την εξουθένωση",
      "subtitle": "Πάρτε μια ανάσα ανάμεσα σε δύο περιόδους φιλοξενίας ανταλλάσσοντας το σπίτι σας."
    },
    "slogan8": {
      "title": "Το πνεύμα του ταξιδιού,",
      "highlight": "το αληθινό",
      "subtitle": "Γνωρίστε άλλους οικοδεσπότες και ανακαλύψτε νέα μέρη με χαμηλό κόστος."
    },
    "slogan9": {
      "title": "100% Κατασκευασμένο στη Γαλλία",
      "highlight": "(Πικαρδία)",
      "subtitle": "Όχι Silicon Valley, αλλά Κοιλάδα του Άνω Σομ. Μια πλατφόρμα χειροποίητη, ανθρώπινη και περήφανη για τις ρίζες της."
    }
  }
};
